module.exports = __webpack_public_path__ + "static/media/googleLogo.e1d54c82.svg";